import styled from 'vue-styled-components';
import { CUSTOM_SCROLL } from '@/styles/common.styled';

export const LinkedWidgetsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    height: 100%;
    max-height: 400px;
    padding: 16px;
    background-color: #fff;
    overflow-y: auto;
    ${CUSTOM_SCROLL}
`;

export const LinkedWidgetsItem = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background-color: #f0f5fc;
    color: #000000;
`;

export const LinkedWidgetsItemTitle = styled.span`
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;
